import { AppConsts } from '@shared/AppConsts';

/**
 * When true, Stay Bookings and Cancellation Requests are omitted from the sidebar.
 * Routes remain registered; users with permission can open them by direct URL.
 *
 * Controlled by `hideStayAdminNavInSidebar` in appconfig*.json (production: true).
 */
export function isStayAdminNavHidden(): boolean
{
    return AppConsts.hideStayAdminNavInSidebar === true;
}
